import { render, staticRenderFns } from "./mergePools.vue?vue&type=template&id=917bbca2&scoped=true"
import script from "./mergePools.vue?vue&type=script&lang=ts"
export * from "./mergePools.vue?vue&type=script&lang=ts"
import style0 from "./mergePools.vue?vue&type=style&index=0&id=917bbca2&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917bbca2",
  null
  
)

export default component.exports